var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
	var len = len - (s + '').length;
	for (var i = 0; i < len; i++) {
		s = '0' + s;
	}
	return s;
};

export default {
	getQueryStringByName: function (name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var r = window.location.search.substr(1).match(reg);
		var context = "";
		if (r != null)
			context = r[2];
		reg = null;
		r = null;
		return context == null || context == "" || context == "undefined" ? "" : context;
	},
	formatDate: {


		format: function (date, pattern) {
			pattern = pattern || DEFAULT_PATTERN;
			return pattern.replace(SIGN_REGEXP, function ($0) {
				switch ($0.charAt(0)) {
					case 'y':
						return padding(date.getFullYear(), $0.length);
					case 'M':
						return padding(date.getMonth() + 1, $0.length);
					case 'd':
						return padding(date.getDate(), $0.length);
					case 'w':
						return date.getDay() + 1;
					case 'h':
						return padding(date.getHours(), $0.length);
					case 'm':
						return padding(date.getMinutes(), $0.length);
					case 's':
						return padding(date.getSeconds(), $0.length);
				}
			});
		},
		parse: function (dateString, pattern) {
			var matchs1 = pattern.match(SIGN_REGEXP);
			var matchs2 = dateString.match(/(\d)+/g);
			if (matchs1.length == matchs2.length) {
				var _date = new Date(1970, 0, 1);
				for (var i = 0; i < matchs1.length; i++) {
					var _int = parseInt(matchs2[i]);
					var sign = matchs1[i];
					switch (sign.charAt(0)) {
						case 'y':
							_date.setFullYear(_int);
							break;
						case 'M':
							_date.setMonth(_int - 1);
							break;
						case 'd':
							_date.setDate(_int);
							break;
						case 'h':
							_date.setHours(_int);
							break;
						case 'm':
							_date.setMinutes(_int);
							break;
						case 's':
							_date.setSeconds(_int);
							break;
					}
				}
				return _date;
			}
			return null;
		}

	},
	//特殊符号验证
	isExistsSymbol: function (value) {
		//除了“_”以外的所有符号都参与验证
		var reg = "!@#$^&*()=|{}':;',\\[\\].<>/?\~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+-[]\"《》\·\`";
		for (var i = 0; i < value.length; i++) {
			if (reg.indexOf(value[i]) >= 0) {
				return true;
			}
		}
		return false;
	},
	getLocalTime: function () {
		var oDay = new Date();
		// oDay.getYear(); //当前年份
		// oDay.getFullYear(); //完整的年月日（xx年，xx月，xx日）
		// oDay.getMonth(); //当前的月份(0-11,0代表1月)         // 获取当前的月份是oDay.getMonth()+1;   <br>oDay.getDate(); //当前的日(1-31) 
		// oDay.getDay(); //当前的星期X(0-6,0代表星期天) 
		// oDay.getTime(); //当前的时间(从1970.1.1开始的毫秒数) 
		// oDay.getHours(); //当前的小时数(0-23) 
		// oDay.getMinutes(); //当前的分钟数(0-59) 
		// oDay.getSeconds(); //当前的秒数(0-59) 
		// oDay.getMilliseconds(); //当前的毫秒数(0-999) 
		// oDay.toLocaleDateString(); //当前的日期 
		return oDay.getHours() + ":" + oDay.getMinutes() + ":" + oDay.getSeconds();
	},
	IsEmptyString: function (value) {
		if (value == null || value == undefined || value == "") {
			return true;
		}

		return false;
	}
};



// WEBPACK FOOTER //
// ./src/common/js/util.js